import { gql } from "generated-graphql";

export const STATE_WASTE_STREAM_REGISTRATIONS_QUERY = gql(`
  query StateWasteStreamRegistrations(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    stateWasteStreamRegistrations(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        id
        tenantId
        tenantName
        facilityId
        state
        stateRegisteredId
        status
        registeredAt
        closedAt
        federalWasteCodes
        formCodes
        sourceCode
        dotId
        dotDescription
        name
        linkedWasteStreamCount
        facility {
          id
          name
        }
      }
      count
    }
  }
`);

export const UPDATE_STATE_WASTE_STREAM_REGISTRATION = gql(`
  mutation UpdateStateWasteStreamRegistration($input: UpdateStateWasteStreamRegistrationInput!) {
    updateStateWasteStreamRegistration(input: $input) {
      id
      status
      stateRegisteredId
      federalWasteCodes
    }
  }
`);

export const CREATE_STATE_WASTE_STREAM_REGISTRATION = gql(`
  mutation CreateStateWasteStreamRegistration($input: CreateStateWasteStreamRegistrationInput!) {
    createStateWasteStreamRegistration(input: $input) {
      id
    }
  }
`);
